module.exports = __webpack_public_path__ + "img/f.75355c7f.png";